import { ComponentProps } from 'react'
import { IconButton, NumberField } from '@alto-avios/alto-ui'
import styles from './QuantityStepper.module.scss'

// Alto 5.11.0 made NumberField accept string or number values, typing onChange as a union of two
// call signatures that TypeScript cannot use to infer a parameter. Every stepper here passes a
// string value, and Alto mirrors that type back, so onChange is narrowed to the string signature
type QuantityStepperProps = Omit<ComponentProps<typeof NumberField>, 'children' | 'onChange'> & {
  onChange?: (value: string) => void
}

const QuantityStepper = ({ className, ...props }: QuantityStepperProps) => {
  const wrapperClass = [styles.stepper, className].filter(Boolean).join(' ')
  return (
    <div className={wrapperClass}>
      <NumberField {...props}>
        <NumberField.StartSlot decrement>
          <IconButton
            emphasis="quaternary"
            iconProps={{ iconName: 'minus', iconPrefix: 'fas' }}
            size="sm"
            styleVariant="neutral"
          />
        </NumberField.StartSlot>
        <NumberField.EndSlot increment>
          <IconButton
            emphasis="quaternary"
            iconProps={{ iconName: 'plus', iconPrefix: 'fas' }}
            size="sm"
            styleVariant="neutral"
          />
        </NumberField.EndSlot>
      </NumberField>
    </div>
  )
}

export default QuantityStepper
